import {
  Fragment,
  type FC
} from 'react';
import {
  Box,
  Button
} from '@mui/joy';
import {
  buttonBG,
} from '../assets';

export type ChallengeButtonProps = {
  readyToClaim: boolean;
};

export const ChallengeButton: FC<ChallengeButtonProps> = ({
  readyToClaim
}) => {
  return (
    <Fragment>
      {readyToClaim ? (
        <Button
          color='success'
          sx={{
            zIndex: 4,
            top: '50%',
            left: '50%',
            minWidth: 108,
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            minHeight: 'var(--Button-minHeight, 2.5rem)',
          }}>
          Claim now
        </Button>
      ) : (
        <Button
          color='success'
          disabled
          sx={{
            left: 4,
            bottom: 4,
            zIndex: 0,
            padding: 0,
            maxWidth: 85,
            minWidth: 85,
            minHeight: 28,
            position: 'absolute',
          }}>
          Claimed
        </Button>
      )}
      {readyToClaim && (
        <Box
          component='img'
          src={buttonBG.default}
          sx={{
            zIndex: 3,
            width: 300,
            top: '50%',
            left: '50%',
            position: 'absolute',
            transform: 'translate(-56%, -50%)'
          }}
        />
      )}
    </Fragment>
  );
};